import React, { useState } from 'react';

export default function Toggle({
  color,
  gradeBgColor,
  optionLeft,
  optionMiddle,
  optionRight,
  onChange,
  selectedOption,
  disabled = false
}) {
  const handleOptionClick = (option) => {
    if (!disabled) {
      onChange(option);
    }
  };

  const gridColumns = optionMiddle ? 'md:grid-cols-3' : 'md:grid-cols-2';

  return (
    <div className={` grid sm:grid-cols-1 ${gridColumns} md:justify-between justify-center`}>
      <button
        className={`px-4 py-2 mb-2 md:mr-2 sm:mr-0 rounded-md focus:outline-none ${selectedOption === optionLeft ? `bg-${color}-${gradeBgColor} font-semibold text-sm text-white shadow-md` : `font-semibold text-sm bg-white border border-solid-2 border-gray-200 shadow-md text-gray-700`}`}
        onClick={() => handleOptionClick(optionLeft)}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {optionLeft}
      </button>
      {optionMiddle && (
        <button
          className={`px-4 py-2 mb-2 md:mr-2 sm:mr-0 rounded-md focus:outline-none ${selectedOption === optionMiddle ? `bg-${color}-${gradeBgColor} font-semibold text-sm text-white shadow-md` : `font-semibold text-sm bg-white border border-solid-2 border-gray-200 shadow-md text-gray-700`}`}
          onClick={() => handleOptionClick(optionMiddle)}
          disabled={disabled}
          aria-disabled={disabled}
        >
          {optionMiddle}
        </button>
      )}
      <button
        className={`px-4 mb-2 py-2 rounded-md focus:outline-none ${selectedOption === optionRight ? `bg-${color}-${gradeBgColor} font-semibold text-white text-sm shadow-md` : `font-semibold text-sm bg-white border border-solid-2 border-gray-200 shadow-md text-gray-700`}`}
        onClick={() => handleOptionClick(optionRight)}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {optionRight}
      </button>
    </div>
  );
}
